/**
 * @author Muhammad Fahad
 * @datetime September, 30th 2022
 * @description: This component is for assigning device group. As per change in requirements,
 *               we are not adding this screen in flow. However, this will remain as it is.
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { PageName } from 'src/app/shared/utils/user-roles';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-assign-device-group',
  templateUrl: './assign-device-group.component.html',
  styleUrls: ['./assign-device-group.component.scss'],
})
export class AssignDeviceGroupComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();

  deviceGroupList!: Array<Object>;
  formGroup!: FormGroup;
  name!: string;
  radionButtons!: Array<Object>;

  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  readonly PageName = PageName;

  constructor(
    private rootFormGroup: FormGroupDirective,
    public commonService: CommonService,
    private localizationService: LocalizationService
  ) {}

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.deviceGroupList = [];
    // this is preparing a static list to show device group
    for (let i = 0; i < 10; i++)
      this.deviceGroupList.push({
        deviceId: i,
        deviceName: i,
        description: i,
      });

    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;

    this.name = this.formGroup?.controls?.name?.value;

    // radio button list manage for active status
    // this is a static list to show groups
    this.radionButtons = [
      {
        label: 'Property Manager Admin',
        name: 'group',
        value: 'Property Manager Admin',
        desc: 'Gain access to sites, buildings, units, doors/access points as approved.',
        active: false,
      },
      {
        label: 'Property Manager User',
        name: 'group',
        value: 'Property Manager User',
        desc: 'Can add and manage units, locks (entry points) in a unit and manage devices.',
        active: false,
      },
      {
        label: 'Installer Admin',
        name: 'group',
        value: 'Installer Admin',
        desc: 'Privileges for the property, buildings, units, and all locks and devices in the property.',
        active: false,
      },
      {
        label: 'Installer User',
        name: 'group',
        value: 'Installer User',
        desc: 'Can activate and onboard a lock or device, add and manage unit and their locks (entry points) in a unit.',
        active: false,
      },
      {
        label: 'Non Tenant User',
        name: 'group',
        value: 'Non Tenant User',
        desc: 'Can invite a non-tenant Guest, Visitor, Vendor users to have limited or unlimited access to locks or devices.',
        active: false,
      },

      {
        label: 'Tenant Admin',
        name: 'group',
        value: 'Tenant Admin',
        desc: 'Can only invite other users with tenant or guest-level privileges to use their units lock(s) and or those common area devices as delegated to them by the property manager.',
        active: false,
      },

      {
        label: 'Tenant Guest User',
        name: 'group',
        value: 'Tenant Guest User',
        desc: 'Can invite a Guest user to have limited access to their unit and personal locks and or those common area devices.',
        active: false,
      },
    ];

    this.radionButtons.map((deviceGroup: any) => {
      if (deviceGroup.value === this.formGroup?.controls?.deviceGroup?.value) {
        deviceGroup.active = true;
      }
    });
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef.close();
  }

  assignDeviceGroup() {
    const filtered = this.radionButtons.filter(
      (accesspoint: any) => accesspoint.active
    );
    this.formGroup.patchValue({ group: filtered });
    this.stepper++;
    this.stepperChange.emit(this.stepper);
  }

  navigateBack() {
    this.stepper--;
    this.stepperChange.emit(this.stepper);
  }

  /**
   * @description current selected group index mark as active status
   * @param userGroup active number
   */
  activate(deviceGroup: any): void {
    deviceGroup.active = true;
  }
}
